import { selectParticipantByType } from "../../../../../src/features/caseinfo/logic/ParticipantsSlice";
import WorkflowStageInfoBanner from "../../../../../src/features/stageWorkflow/components/WorkflowStageInfoBanner";
import { CaseStageEnum } from "../../../../api/caseStages";
import { useAppSelector } from "../../../../app/store";
import { useLoggedInUserId } from "../../../auth/logic/rbac";
import WorkflowStageBanner from "../../../stageWorkflow/components/WorkflowStageBanner";
import { selectStageConfigByStage } from "../../logic/slice";
import { ParticipantType } from "../../../../../src/api/participants";

const IoAppAuthAssignIoStage: React.FC = () => {
  const loggedInUserId = useLoggedInUserId();

  const ioAppointingAuthorityParticipant = useAppSelector((state) =>
    selectParticipantByType(state, ParticipantType.IO_APPOINTING_AUTHORITY)
  );

  const IOAppointingAuthority = ioAppointingAuthorityParticipant?.participant_id;
  const stageConfig = useAppSelector(selectStageConfigByStage(CaseStageEnum.IO_APP_AUTH_ASSIGN_IO));

  const isIOAppointingAuthority = loggedInUserId === IOAppointingAuthority;

  if (isIOAppointingAuthority) {
    return (
      <WorkflowStageBanner
        title="Appoint Investigating Officer"
        description="Assign Investigating Officer or Forensic Auditor, as applicable to conduct investigation. Your approval will officially commence investigation and notify all stakeholders."
        actions={stageConfig?.actions}
      />
    );
  }

  return (
    <WorkflowStageInfoBanner title="Pending with IO Appointing Authority to Appoint Investigating Officer" />
  );
};

export default IoAppAuthAssignIoStage;